import { h, render } from 'preact';
import { App } from './app';
import { StoreProvider } from './helpers/store-provider';
import createStore from './helpers/create-store';
import { defineCustomElements } from '@bringg/web-components/loader';

import './style.scss';
import { Environment } from '@bringg/frontend-utils/dist/common/types';
import ConfigLoader from '@bringg/frontend-utils/dist/services/config-loader';

import RegionService from './services/region-service';
import { SharedLocationService } from './services/shared-location-service';
import RealTimeService from './services/realtime-service';
import EtaService from './services/eta-service';
import LanguageService from './services/language-service';
import DirectionService from './services/direction-service';
import UserLocationService from './services/user-location-service';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import * as dayjs from 'dayjs';
import TokenService from './services/token-service';
import { CustomerExperienceService } from './services/customer-experience-service';
import AirbrakeService, { airbrakeServiceMock } from './services/airbrake/airbrake-service';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

(async function Init() {
	await defineCustomElements(window);
	dayjs.extend(localizedFormat);
	dayjs.extend(utc);
	dayjs.extend(timezone);
	const envConfig: Environment = await new ConfigLoader().loadWithFetchedRegions();
	const regionService = new RegionService(envConfig);
	const realTimeService = new RealTimeService(regionService.getConfigByRegion());
	const tokenService = new TokenService(envConfig);
	await tokenService.tryFetchCredentials();
	let airbrakeService = airbrakeServiceMock;
	if (envConfig.environment !== 'development') {
		try {
			airbrakeService = new AirbrakeService({
				projectId: envConfig.airbrake_project_id,
				projectKey: envConfig.airbrake_project_key,
				environment: envConfig.environment
			});
		} catch (err) {
			console.error(err);
		}
	}
	const { rootStore, env } = createStore({
		regionService,
		realTimeService,
		airbrakeService,
		langService: new LanguageService(),
		sharedLocationService: new SharedLocationService(),
		customerExperienceService: new CustomerExperienceService(),
		etaService: new EtaService(),
		directionService: new DirectionService(),
		userLocationService: new UserLocationService(),
		tokenService
	});

	const Wrap = () => (
		<StoreProvider value={rootStore}>
			<App />
		</StoreProvider>
	);

	const initApp = async () => {
		await env.langService.init();

		render(<Wrap />, document.body);
	};

	await initApp();
})();
